import { ButtonFinal } from "@kalyzee/escaet-ui";
import { AppVersion, Touchable } from "@kalyzee/kast-web-sdk/web-components";
import { ReactComponent as IconBack } from "../../../assets/icons/back.svg";
import { usePageContextRef } from "../../../components/navigation/PageContext";
import { useLogger } from "../../../helpers/logger";
import { useAppDispatch } from "../../../hooks/app";
import { logout } from "../../../store/session/slices";
import styles from "./logout.module.css";

const LogoutPage = () => {
  const dispatch = useAppDispatch();
  const pageContextRef = usePageContextRef();
  const logger = useLogger();

  const onLogout = () => {
    logger.log("[LOGOUT] : on logout button press");
    dispatch(logout());
  };

  return (
    <div className={styles.container}>
      <Touchable
        onPress={() => {
          pageContextRef.current?.goToPrevious();
        }}
        className={styles.backButton}
      >
        <IconBack width="100%" height="100%" />
      </Touchable>
      <div style={{ minWidth: "200px" }}>
        <ButtonFinal
          text="Se déconnecter"
          background="#4b4b4b"
          cx="!text-white !py-[20px] !w-full !rounded-[10px] !font-bold !text-[16px]"
          onClick={onLogout}
        />
      </div>
      <AppVersion />
    </div>
  );
};

export default LogoutPage;
